import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EditCustomInvestigationForm } from './components/form/EditCustomInvestigationForm';
import { useLoadCustomInvestigationDependencies } from '../useLoadCustomInvestigationDependencies';
import { useLoadInvestigation } from '../useLoadInvestigation';
import { isCustomInvestigation } from '@customer/shared/utils/investigationHelper';
import { ModelName } from '@customer/store/types';

export const EditCustomInvestigationPanel = (): ReactElement => {
  const { t } = useTranslation();

  const model = useLoadInvestigation();
  const dependencies = useLoadCustomInvestigationDependencies();
  const isLoaded = model.isLoaded && dependencies.isLoaded;
  const renderKey = [model.renderKey, dependencies.renderKey].join('');

  return (
    <DrawerPanel
      isLoaded={isLoaded}
      header={t('Model.Edit.Title', { modelName: ModelName.Investigation })}
    >
      {model.investigation && isCustomInvestigation(model.investigation) && (
        <EditCustomInvestigationForm
          key={renderKey}
          investigation={model.investigation}
          assets={dependencies.assets ?? []}
        />
      )}
    </DrawerPanel>
  );
};

export default EditCustomInvestigationPanel;
